export default __webpack_public_path__ + "static/media/mbfcTower3.jpg?.0c740123";